import Model from '../../models/model';

const model = new Model({
	name: 'ChangePassword',
	columns: [
		{
			field: 'OldPassword',
			label: 'CurrentPassword',
			type: 'password',
			inlineLabelSize: 12,
			skipPasswordStrengthCheck: true,
			required: true
		},
		{
			field: 'NewPassword',
			label: 'NewPassword',
			type: 'password',
			inlineLabelSize: 12,
			required: true
		},
		{
			field: 'ConfirmPassword',
			label: 'ConfirmPassword',
			type: 'password',
			inlineLabelSize: 12,
			required: true,
			validate: 'compare:NewPassword'
		}
	]
});

export default model.createFormDialog();
